import React from "react";
import ReactDOM from "react-dom";
import Main from "./Main.js";
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(React.createElement(Main, null), document.querySelector("#container"));
